import { IS_PUBLIC, IS_STOCK } from 'reactApp/appHelpers/configHelpers';
import { isFamilyQuotaInSpaceEnabled, isFamilySubsAvailable } from 'reactApp/appHelpers/featuresHelpers';

export const IS_USER_AND_FAMILY_QUOTA_ENABLED = isFamilySubsAvailable && isFamilyQuotaInSpaceEnabled && !IS_STOCK && !IS_PUBLIC;
